import { render, staticRenderFns } from "./WazdanFreespins.vue?vue&type=template&id=628142c5&"
import script from "./WazdanFreespins.vue?vue&type=script&lang=js&"
export * from "./WazdanFreespins.vue?vue&type=script&lang=js&"
import style0 from "./WazdanFreespins.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports